import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, target }) => {
  const isSection = target?.type === "section";
  const itemCount = isSection ? target?.data?.items?.length || 0 : 0;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Delete</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Alert status="warning" borderRadius="md">
              <AlertIcon />
              <VStack align="start" spacing={1}>
                <AlertTitle>Are you sure?</AlertTitle>
                <AlertDescription>
                  This action cannot be undone.
                </AlertDescription>
              </VStack>
            </Alert>

            {target && (
              <Text>
                You are about to delete the {isSection ? "section" : "item"}:{" "}
                <Text as="span" fontWeight="bold">
                  {target.data?.title}
                </Text>
              </Text>
            )}

            {isSection && itemCount > 0 && (
              <Alert status="error" borderRadius="md">
                <AlertIcon />
                <VStack align="start" spacing={1}>
                  <AlertTitle>Warning!</AlertTitle>
                  <AlertDescription>
                    This section contains {itemCount} item
                    {itemCount !== 1 ? "s" : ""}. Deleting this section will
                    also delete all items within it.
                  </AlertDescription>
                </VStack>
              </Alert>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={onConfirm}>
            Delete {isSection ? "Section" : "Item"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteConfirmModal;
